import { InspectionHistoryData, InspectionCommentsData } from "../Home/InspectionHistory.types";
import { ComplianceData } from "../Components/DrainFieldInstallationInspectionForm.types";

/**
 * Helper functions for transforming final inspection data
 */

// Convert string/boolean to boolean
export const toBoolean = (value: string | boolean | undefined): boolean | undefined => {
    if (value === undefined || value === null) return undefined;
    if (typeof value === "boolean") return value;
    if (typeof value === "string") {
        const lower = value.toLowerCase().trim();
        return lower === "yes" || lower === "true" || lower === "1";
    }
    return undefined;
};

// Convert value to number, filtering out invalid values
export const toPositiveNumber = (value: string | number | undefined): number | undefined => {
    if (value === undefined || value === null) return undefined;
    const num = typeof value === "number" ? value : Number(value);
    return (num && num > 0) ? num : undefined;
};

// Convert value to string
export const toString = (value: string | number | undefined): string | undefined => {
    if (value === undefined || value === null) return undefined;
    return typeof value === "string" ? value : String(value);
};

// Normalize elevation benchmark (above = "1", below = "2")
export const normalizeElevationBenchmark = (value: string | number | undefined): string | undefined => {
    if (value === undefined || value === null) return undefined;
    if (typeof value === "string") {
        const trimmed = value.trim().toLowerCase();
        if (trimmed === "above" || trimmed === "1" || trimmed === "333") return "1";
        return "2";
    }
    if (typeof value === "number") {
        return (value === 1 || value === 333) ? "1" : "2";
    }
    return undefined;
};

// Get compliance ID from compliance string
export const getComplianceIdFromString = (
    complianceString: string | undefined,
    complianceData: ComplianceData[]
): number | undefined => {
    if (!complianceString || !complianceData || complianceData.length === 0) return undefined;
    const found = complianceData.find(c => c.name === complianceString);
    return found?.id;
};

// Get comment by field name
export const getCommentByFieldName = (
    fieldName: string,
    comments: InspectionCommentsData[]
): string => {
    const comment = comments.find(c => c.inspectionFieldName === fieldName);
    return comment?.comment || '';
};

// Check if a compliance string has meaningful value
export const hasMeaningfulCompliance = (value: string | undefined): boolean => {
    if (!value || typeof value !== "string") return false;
    const trimmed = value.trim();
    return trimmed !== "" && trimmed.toLowerCase() !== "n/a" && trimmed !== "-1";
};

// Check if a string has meaningful value
export const hasMeaningfulString = (value: string | undefined): boolean => {
    if (!value || typeof value !== "string") return false;
    const trimmed = value.trim();
    return trimmed !== "" && trimmed !== "-1";
};

